import axios from "axios";
import { BASE_URL} from "../../Config/BaseUrl";
const token = localStorage.getItem("token");
const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};
export const StudentBusMappingAPI = {
    studentlistforRouteMapping : async (data) => {
        const axiosConfig = createAxiosConfig("student_list_for_route_mapping","POST", data);
        return await axios(axiosConfig);
      },
      checkStudentRoutemappedApi : async (data) => {
        const axiosConfig = createAxiosConfig("check_Student_routemapped_api","POST", data);
        return await axios(axiosConfig);
      },
      changePickupPointapi : async (data) => {
        const axiosConfig = createAxiosConfig("change_PickupPointapi","POST", data);
        return await axios(axiosConfig);
      },
      studentStopBusApi : async (data) => {
        const axiosConfig = createAxiosConfig("student_stop_bus_api","POST", data);
        return await axios(axiosConfig);
      }
}